import { defineStore } from "pinia";
 
export const useCustomerDistrictStore = defineStore("customerDistrictStore", () => {

   

    async function getAdPlacePaginate(filter) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/place/paginate`,{
            method: 'GET',
            params:{
              ...filter
            }
           })
      
                             
            return {
              success: data?.success,
              data: data?.data
            };
         
        } catch (error) {
    

          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
       
      async function adPlaceCreate(district) {
        try {
          
          const data = await useNuxtApp().$apiAuth(`/api/ad/place/create`,{
            method: 'POST',
            body:{
              ...district
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function adPlaceUpdate(district) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/place/update`,{
            method: 'PUT',
            body:{
              ...district
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
          
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function adPlaceDelete(id) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/place/delete/${id}`,{
            method: 'DELETE',      
          })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
     
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function placeCacheStore() {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/place/cache/set`,{
            method: 'GET'
           })
            return {
              success: data?.success,
              data: data?.data,
            };
         
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getPlaceCache(input) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/place/cache/get`,{
            method: 'GET',
            use: input
           })        
       return {
              success: true,
              data: data?.data,
            };
           
        } catch (error) {
        

          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getPlaceByName(name) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/place/by/name`,{
            method: 'GET',
            use: 'customer',
            params:{
              search: name
            }
           })        
       return {
              success: true,
              data: data?.data,
            };
           
        } catch (error) {
        


          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getPlaceById(id) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/place/by/id`,{
            method: 'GET',
            use: 'customer',
            params:{
              id: id
            }
           })        
       return {
              success: true,
              data: data?.data,
            };
           
        } catch (error) {
        

          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
        async function getPlacePaginateCache(param) {
        try {
          const {data} = await useNuxtApp().$apiAxios.get(`/api/ad/place/cache/paginate/get`,{
            params:{
              ...param
            }
           })        
          
          
            return {
              success: true,
              data: data?.data,
            };
           
        } catch (error) {
      return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
    return {
        getAdPlacePaginate,
        adPlaceCreate,
        adPlaceUpdate,
        adPlaceDelete,
        getPlaceCache,
        placeCacheStore,
        getPlacePaginateCache,
        getPlaceByName,
        getPlaceById


    }
})
